import { createContext } from "react";
import type { FeatureFlags } from "./FeatureFlags";

export const FeatureFlagContext = createContext<FeatureFlags<unknown> | null>(
  null
);
